import { useApi } from '../../core/api/api.context';
import { useQueries, useQuery } from 'react-query';
import { QueryKeys } from '../../core/queries/query-keys.constants';
import { AccountDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { RestError } from '@azure/core-http';

export const useQueryListAccounts = () => {
  const api = useApi();

  return useQuery(QueryKeys.ACCOUNTS, async () => {
    return await api.accountsController.list();
  });
};

export const useQueryGetAccount = (id: string) => {
  const api = useApi();
  return useQuery<AccountDto, RestError>([QueryKeys.ACCOUNTS, id], async () => {
    return await api.accountsController.get(id);
  });
};

export const useQueryGetAccounts = (ids: string[]) => {
  const api = useApi();
  const queries = ids.map((id) => ({
    queryKey: [QueryKeys.ACCOUNTS, id],
    queryFn: () => api.accountsController.get(id)
  }));
  return useQueries(queries);
};

export const useQueryGetAccountTeamMemberships = (id: string) => {
  const api = useApi();
  return useQuery([QueryKeys.ACCOUNTS, id, QueryKeys.TEAM_MEMBERS], async () => {
    return await api.accountsController.projectsList(id);
  });
};
